// API root. Both legacy variables (BASE_URL, BASE_URL_2) always pointed to
// REACT_APP_BASE_URL_2, so it remains the single source of truth.
export const BASE_URL = process.env.REACT_APP_BASE_URL_2;
